/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderBuyerOrderIdUpdateRequestDTO interface.
 */
export function instanceOfOrderBuyerOrderIdUpdateRequestDTO(value) {
    if (!('buyerOrderId' in value) || value['buyerOrderId'] === undefined)
        return false;
    return true;
}
export function OrderBuyerOrderIdUpdateRequestDTOFromJSON(json) {
    return OrderBuyerOrderIdUpdateRequestDTOFromJSONTyped(json, false);
}
export function OrderBuyerOrderIdUpdateRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'buyerOrderId': json['buyerOrderId'],
    };
}
export function OrderBuyerOrderIdUpdateRequestDTOToJSON(json) {
    return OrderBuyerOrderIdUpdateRequestDTOToJSONTyped(json, false);
}
export function OrderBuyerOrderIdUpdateRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'buyerOrderId': value['buyerOrderId'],
    };
}
